import { configureStore, PreloadedState } from '@reduxjs/toolkit'
import appReducer from './appSlice'

export const reducers = {
  app: appReducer,
}

export const createAppStore = (preloadedState?: PreloadedState<any>) =>
  configureStore({
    reducer: reducers,
    preloadedState: preloadedState,
  })

export const store = createAppStore()

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
